import { FC, useRef, useState } from 'react'
import styles from './YogaResults.module.scss'
import { YogaResultsProps } from './YogaResults.types'
import { Icon } from 'components/Phantom/Icon'
import { CountUp } from 'components/CountUp'
import { useGSAP } from '@gsap/react'
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'

export const YogaResults: FC<YogaResultsProps> = (props) => {
	const {} = props
	return (
		<section
			className={styles.container}
			id={'clinical_results'}
		>
			<h2>After sleeping on the Pod, Eight Sleep members see:</h2>
			<ul className={styles.benefits}>
				{benefits.map((benefit) => (
					<li key={benefit.title}>
						<BenefitCard
							title={benefit.title}
							direction={benefit.direction}
							number={benefit.number}
							stagger={benefit.stagger}
						/>
					</li>
				))}
			</ul>
		</section>
	)
}

const benefits = [
	{
		title: 'Increased deep and REM sleep',
		direction: 1,
		number: 15,
		stagger: 0,
	},
	{
		title: 'Enhanced cardiovascular recovery',
		direction: 1,
		number: 15,
		stagger: 1,
	},
	{
		title: 'Decrease in sleeping heart rate',
		direction: 0,
		number: 13,
		stagger: 0,
	},
	{
		title: 'Improved sleep quality',
		direction: 1,
		number: 25,
		stagger: 1,
	},
	{
		title: 'Higher daytime energy scores',
		direction: 1,
		number: 34,
		stagger: 0,
	},
	{
		title: 'Faster sleep onset',
		direction: 1,
		number: 44,
		stagger: 1,
	},
]

const BenefitCard = ({ title, direction, number, stagger }) => {
	const titleRef = useRef(null)
	const cardRef = useRef(null)

	const [timeline, setTimeline] = useState<gsap.core.Timeline | null>(null)

	useGSAP(
		() => {
			gsap.registerPlugin(ScrollTrigger)
			if (!timeline) return

			const tl = gsap.timeline({
				ease: 'none',
				scrollTrigger: {
					trigger: cardRef.current,
					start: `${stagger * 60}px 95%`,
					end: '+=150px',
					toggleActions: 'restart none none reverse',
				},
			})

			tl.fromTo(
				cardRef.current,
				{
					opacity: 0,
					y: 100,
				},
				{
					opacity: 1,
					y: 0,
					duration: 1,
				},
				0
			)
			tl.add(timeline, 0)
		},
		{
			dependencies: [timeline],
			revertOnUpdate: true,
		}
	)

	const handleCountUpTimelineReady = (timeline: gsap.core.Timeline) => {
		setTimeline(timeline)
	}

	return (
		<div
			className={styles.benefit_card}
			ref={cardRef}
		>
			<div className={styles.title}>
				<Icon
					name={direction ? 'ArrowUpDark' : 'ArrowDownDark'}
					color={'#1862ff'}
				/>
				<h3 ref={titleRef}>
					<CountUp
						endValue={number}
						trigger={true}
						duration={1}
						onTimelineReady={handleCountUpTimelineReady}
					/>
					%
				</h3>
			</div>
			<p>{title}</p>
		</div>
	)
}
